function Footer() {
    return (
        <footer>© Andreas B.-G. 2026/2027</footer>
    );
};
// Bjerke videregående skole 2026/2027
export default Footer;